/**
 * Lightweight dev-only logger.
 * - In development: forwards to console.* methods
 * - In production: warns and errors are kept (debugging prod issues), info/debug stripped
 */
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  debug: (...args) => {
    if (isDev) console.debug(...args);
  },
  info: (...args) => {
    if (isDev) console.info(...args);
  },
  warn: (...args) => {
    console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
};

export default logger;
